import { Content } from "@/components/Blocks/usps/components/components/content";
import { Icon } from "@/components/Blocks/usps/components/components/icon";
import { Text } from "@/components/Blocks/usps/components/components/text";
import { useUspContext } from "@/components/Blocks/usps/components/context/usp.context";
import { Base } from "@/components/Blocks/usps/components/usp.base";

export const Usp = Object.assign(Base, {
    useContext: useUspContext,
    Content: Content,
    Icon: Icon,
    Text: Text
});
